import { CONSTANTS } from './const';
export var getPidMcsMenu = function (translate) {
    return [
        {
            id: 'pid_cms',
            label: translate('pidCms'),
            path: 'pid-cms',
            underline: false,
            openInNew: false,
            children: [
                {
                    id: 'pid_cms_display',
                    path: CONSTANTS.ROUTES.DISPLAY,
                    label: translate('display'),
                    underline: false,
                    openInNew: false,
                    parentId: 'mobility_inform',
                },
                {
                    id: 'pid_cms_campaign',
                    path: CONSTANTS.ROUTES.CAMPAIGNS,
                    label: translate('campaigns'),
                    underline: false,
                    openInNew: false,
                    parentId: 'mobility_inform',
                },
                {
                    id: 'pid_cms_image_library',
                    path: CONSTANTS.ROUTES.IMAGE_LIBRARY,
                    label: translate('imageLibrary'),
                    underline: false,
                    openInNew: false,
                    parentId: 'mobility_inform',
                },
                {
                    id: 'pid_cms_broadcast_text_message',
                    label: translate('broadcastTextMessage'),
                    path: CONSTANTS.ROUTES.BROADCAST_TEXT_MESSAGE,
                    underline: false,
                    openInNew: false,
                    parentId: 'mobility_inform',
                },
                {
                    id: 'pid_cms_geofence',
                    label: translate('geofence'),
                    path: CONSTANTS.ROUTES.GEOFENCE,
                    underline: false,
                    openInNew: false,
                    parentId: 'mobility_inform',
                },
                {
                    id: 'pid_cms_route',
                    label: translate('route'),
                    path: CONSTANTS.ROUTES.ROUTE,
                    underline: false,
                    openInNew: false,
                    parentId: 'mobility_inform',
                },
                {
                    id: 'pid_cms_stop',
                    label: translate('stop'),
                    path: CONSTANTS.ROUTES.STOP,
                    underline: false,
                    openInNew: false,
                    parentId: 'mobility_inform',
                },
            ],
        },
    ];
};
